export const availableInBuilder: string[] = [
    's-acp-tabs',
    's-anchor-menu',
    's-asset-cards',
    's-award-compact',
    's-award-highlight',
    's-awards',
    's-awards-ribbon',
    's-cards-highlight',
    's-cards-product',
    's-cards-product-list',
    's-cards-small',
    's-cards-small-slider',
    's-cards-support',
    's-cards-with-icon',
    's-compete-page',
    's-cta',
    's-cta-discount-code',
    's-cta-simple',
    's-cta-with-image',
    's-customizable-header',
    's-data-centers-local',
    's-download',
    's-event-questions',
    's-event-location',
    's-faq',
    's-features-large',
    's-features-small',
    's-g2-reviews',
    's-header-lp-three-products',
    's-header-lp-two-products-2026',
    's-header-message',
    's-header-product-new',
    's-header-simple',
    's-insertion',
    's-integrations',
    's-intro',
    's-message-highlights',
    's-mobile-app-highlight',
    's-numbers',
    's-partner-logos-carousel',
    's-product-reviews',
    's-promo-countdown',
    's-requirements',
    's-requirements-combo',
    's-resources',
    's-schema-switcher',
    's-site-search',
    's-subscription',
    's-supported-systems',
    's-tabs',
    's-trial-form',
    's-value-cards',
    's-video-featured',
    's-webinar',
];
